import { IPkDialogData, IPkFormDialogCompanion } from '../../../pk-dialog/pk-dialog-data';
import { Validators } from '@angular/forms';
import { getDefaultDialogButtons, getNazevSettings } from '../common-settings-objects';
import { IPkInputTextFieldProps } from '../../../pk-input-fields/pk-input-text-field/pk-input-text-field.props';
import { IPkSelectFieldProps } from '../../../pk-input-fields/pk-select-field/pk-select-field.props';
import { IPkColorPickerProps } from '../../../pk-input-fields/pk-color-picker-field/pk-color-picker-field.props';
import { EntityTypes } from '@nx-monorepo/obce/common/enums';
import { IPkInputEntityFieldProps } from '../../../pk-input-fields/pk-input-entity-field/pk-input-entity-field.props';
import { UredniDeskyBarrel } from '@nx-monorepo/node-frontend';

export class PkGridsterItemUredniDeskyCompactDialogCompanion implements IPkFormDialogCompanion {
  getDialogData(settings: UredniDeskyBarrel.CompactUredniDeskyProps, data: {}, emitters: {dialogSubmit, dialogClose}) {
    const dialogData: IPkDialogData = {
      title: 'Upravit úřední desky',
      components: [
        getNazevSettings(settings.nazev),
        {
          componentName: 'PkColorPickerFieldComponent',
            settings: {
              defaultValue: settings.secondaryColor ? settings.secondaryColor : '',
              showAlways: false,
              povinnost: false,
              type: 'text',
              nazev: 'Sekundární barva???',
              formControlName: 'secondaryColor',
            } as IPkColorPickerProps,
            data: null,
            validators: [],
            cols: 2,
            x: 0,
            y: 0,
          },
          {
            componentName: 'PkColorPickerFieldComponent',
            settings: {
              showAlways: false,
              povinnost: false,
              type: 'text',
              nazev: 'Accent color???',
              formControlName: 'accentColor',
              defaultValue: settings.accentColor ? settings.accentColor : '',
            } as IPkColorPickerProps,
            data: null,
            validators: [],
            cols: 4,
            x: 0,
            y: 1,
          },
          {
            componentName: 'PkColorPickerFieldComponent',
            settings: {
              showAlways: false,
              povinnost: false,
              type: 'text',
              nazev: 'Barva textu',
              formControlName: 'textColor',
              defaultValue: settings.textColor ? settings.textColor : '',
            } as IPkColorPickerProps,
            data: null,
            validators: [],
            cols: 4,
            x: 0,
            y: 2,
          },
          {
            componentName: 'PkSelectFieldComponent',
            settings: {
              povinnost: true,
              nazev: 'Ikona',
              isMultiple: false,
              formControlName: 'icon',
              defaultValue: settings.icon ? settings.icon : 'faDownload',
            } as IPkSelectFieldProps,
            data: [
              {
                id: 'faDownload',
                nazev: 'faDownload'
              },
              {
                id: 'faAirFreshener',
                nazev: 'faAirFreshener'
              }
            ],
            validators: [Validators.required],
            cols: 1,
            x: 0,
            y: 3,
          },
          {
            componentName: 'PkInputEntityFieldComponent',
            settings: {
              nazev: 'Pozadí sekce',
              povinnost: false,
              isMultiple: false,
              withPreview: true,
              entityType: EntityTypes.Media,
              formControlName: 'sectionBackground',
              defaultValue: settings.sectionBackground ? settings.sectionBackground : null,
            } as IPkInputEntityFieldProps,
            data: null,
            validators: [],
            cols: 4,
            x: 0,
            y: 4
          },
          {
            componentName: 'PkInputEntityFieldComponent',
            settings: {
              nazev: 'Pozadí wrapperu',
              povinnost: false,
              isMultiple: false,
              withPreview: true,
              entityType: EntityTypes.Media,
              formControlName: 'wrapperBackground',
              defaultValue: settings.wrapperBackground ? settings.wrapperBackground : null,
            } as IPkInputEntityFieldProps,
            data: null,
            validators: [],
            cols: 4,
            x: 0,
            y: 5
          },
          {
            componentName: 'PkInputTextFieldComponent',
            settings: {
              isTextArea: false,
              formControlName: 'itemFlexBasis',
              type: 'text',
              nazev: 'Nastavení šířky itemu',
              povinnost: false,
              defaultValue: settings.itemFlexBasis ? settings.itemFlexBasis : ''
            } as IPkInputTextFieldProps,
            data: null,
            validators: [],
            cols: 4,
            x: 0,
            y: 6,
          },
          {
            componentName: 'PkInputBoxFieldComponent',
            settings: {
              nazev: 'Nastavení paddingu itemu',
              formControlName: 'itemPadding',
              povinnost: false,
              defaultValue: settings.itemPadding ? settings.itemPadding : null,
            },
            data: null,
            validators: [Validators.pattern(/^\d+$/)],
            cols: 4,
            x: 0,
            y: 7,
          },
      ],
      buttons: getDefaultDialogButtons(emitters)
    };
    return dialogData;
  }
}
